import { Controller, useFieldArray, useWatch } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";

const ProductSection = ({
  singleIndex,
  deliveryIndex,
  control,
  register,
  getValues,
  errors,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants`,
  });

  const [Diamonds, setDiamond] = useState([]);
  const getAllDiamond = async () => {
    const response = await getData(`/common/masters/all-diamond`);
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };

  useEffect(() => {
    getAllDiamond();
  }, []);

  const [variantsError, setVariantsError] = useState("");


  const PriceAutoCalculator = ({ control, setValue, mrpPath, pricePath }) => {
    const mrp = useWatch({
      control,
      name: mrpPath,
    });

    const discount = useWatch({
      control,
      name: "discount_percentage",
    });

    useEffect(() => {
      const mrpNum = parseFloat(mrp);
      const discountNum = parseFloat(discount);

      if (!mrpNum) {
        setValue(pricePath, "");
        return;
      }

      if (!discount) {
        setValue(pricePath, mrpNum.toFixed(2));
        return;
      }

      const price = mrpNum - (mrpNum * discountNum) / 100;

      setValue(pricePath, price.toFixed(2));
    }, [mrp, discount]);

    return null;
  };



  useEffect(() => {
    register(
      `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants`,
      {
        validate: (value) => {
          const isValid = value && value.length > 0;
          setVariantsError(isValid ? "" : "At least one Diamond is required");
          return isValid;
        },
      },
    );
  }, [register]);
  return (
    <>
      <div>
        {" "}
        {variantsError && <span className="text-danger">{variantsError}</span>}
      </div>

      {fields.map((product, productIndex) => (
        <Row key={product.id} className="mb-3 ">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Thickness</Form.Label>
              <Controller
                control={control}
                name={`variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.diamond_id`}
                rules={{
                  required: "Enter Thickness",
                }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Thickness"
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={onBlur}
                    value={value || ""}
                    ref={ref}
                    style={{
                      borderColor:
                        errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]?.triple_variants?.[productIndex]?.diamond_id
                          ? "red"
                          : undefined,
                    }}
                  />
                )}
              />

              {errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]
                ?.triple_variants?.[productIndex]?.diamond_id && (
                  <span className="text-danger">
                    {
                      errors?.variants?.[singleIndex]?.double_variants?.[
                        deliveryIndex
                      ]?.triple_variants?.[productIndex]?.diamond_id.message
                    }
                  </span>
                )}
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>MRP</Form.Label>
              <Form.Control
                type="text"
                {...register(
                  `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.mrp`,
                  {
                    required: "MRP required",
                    validate: (value) =>
                      value.length <= 200 ||
                      "Data must be 200 characters or less",
                  },
                )}
                onKeyDown={(e) => {
                  // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                  if (
                    !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "."
                  ) {
                    e.preventDefault(); // Prevent the event if it's not allowed
                  }

                  // Prevent entering more than one decimal point
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
              />

              {errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]
                ?.triple_variants?.[productIndex]?.mrp && (
                  <span className="text-danger">
                    {
                      errors?.variants?.[singleIndex]?.double_variants?.[
                        deliveryIndex
                      ]?.triple_variants?.[productIndex]?.mrp.message
                    }
                  </span>
                )}
            </Form.Group>
          </Col>

          <PriceAutoCalculator
            control={control}
            setValue={setValue}
            mrpPath={`variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.mrp`}
            pricePath={`variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.price`}
          />
          <Col md={2}>
            <Form.Group>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                {...register(
                  `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.price`,
                  {
                    required: "Price required",
                    validate: (value) => {
                      const mrp = getValues(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.triple_variants.${productIndex}.mrp`,
                      );

                      if (mrp && Number(value) > Number(mrp)) {
                        return "Price cannot be greater than MRP";
                      }
                      return true;
                    },
                  },
                )}
                onKeyDown={(e) => {
                  // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                  if (
                    !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "."
                  ) {
                    e.preventDefault(); // Prevent the event if it's not allowed
                  }

                  // Prevent entering more than one decimal point
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
              />

              {errors?.variants?.[singleIndex]?.double_variants?.[deliveryIndex]
                ?.triple_variants?.[productIndex]?.price && (
                  <span className="text-danger">
                    {
                      errors?.variants?.[singleIndex]?.double_variants?.[
                        deliveryIndex
                      ]?.triple_variants?.[productIndex]?.price.message
                    }
                  </span>
                )}
            </Form.Group>
          </Col>

          <Col md={12}>
            <button
              type="button"
              className="btn btn-danger mt-2"
              onClick={() => remove(productIndex)}
            >
              Remove Thickness
            </button>
          </Col>
        </Row>
      ))}

      <button
        type="button"
        className="btn btn-secondary me-2"
        onClick={() => append({})}
      >
        + Add Thickness
      </button>
    </>
  );
};

export default ProductSection;
